import React from 'react';
import { FaCalendarAlt } from 'react-icons/fa';
import eventsData from '../config/events.json';

export default function Events() {
  const getEventEmoji = (category) => {
    const emojiMap = {
      'Tournament': '🏆',
      'Seasonal': '🌟',
      'Regular': '⭐',
      'Corporate': '💼'
    };
    return emojiMap[category] || '📅';
  };

  return (
    <section id="events" className="section">
      <h2 className="section-title">Events & Promotions</h2>
      <p className="section-subtitle">Check out our upcoming tournaments, events, and special offers!</p>

      <div className="events-grid">
        {eventsData.events.map((event) => (
          <div key={event.id} className="event-card">
            <div className="event-image">
              {getEventEmoji(event.category)}
            </div>
            <div className="event-content">
              <span className="event-category">{event.category}</span>
              <h3 className="event-title">{event.title}</h3>
              <div className="event-date">
                <FaCalendarAlt />
                {event.date}
              </div>
              <p className="event-description">{event.description}</p>
              <div className="event-discount">
                🎉 {event.discount}
              </div>
            </div>
          </div>
        ))}
      </div>

    </section>
  );
}
